module.exports = __webpack_public_path__ + "img/person.2c591ba9.svg";